module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-74.96abd1d7.svg";